<template>
  <form @submit.prevent="submit" class="sepa-form">
    <div>
      <label for="name">Nom complet</label>
      <input v-model="form.name" id="name" type="text" required />
      <span class="error" v-if="errors.name">{{ errors.name }}</span>
    </div>

    <div>
      <label for="email">Email</label>
      <input v-model="form.email" id="email" type="email" required />
      <span class="error" v-if="errors.email">{{ errors.email }}</span>
    </div>

    <div>
      <label for="iban">IBAN</label>
      <input v-model="form.iban" id="iban" type="text" required />
      <span class="error" v-if="errors.iban">{{ errors.iban }}</span>
    </div>

    <div>
      <label>
        <input type="checkbox" v-model="form.consent" />
        J'autorise le prélèvement SEPA selon le mandat.
      </label>
      <span class="error" v-if="errors.consent">{{ errors.consent }}</span>
    </div>

    <ap-button text="Enregistrer" name="submit" type="submit" tabindex="24" class="payment-buttons" @click="showOrEditSession"/>

  </form>
</template>

<script>
import ApButton from '../../commons/APButton.vue';
import { getPaymentInfos, savePaymentInfos } from '../../../services/personalization'

export default {
    name: 'APPaiement',
    components: {
        ApButton,
    },
    data() {
        return {
            form: {
                name: '',
                email: '',
                iban: '',
                consent: false
            },
            errors: {
                name: '',
                email: '',
                iban: '',
                consent: ''
            },
            loading: false
        }
    },
    mounted() {
        getPaymentInfos().then(response => {
            this.iban = response.iban;
        })
    },
    methods: {
        validateIban(iban) {
            const ibanRegex = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/
            return ibanRegex.test(iban.replace(/\s+/g, '').toUpperCase())
        },
        validateForm() {
            this.errors.name = this.form.name ? '' : 'Le nom est requis.'
            this.errors.email = /\S+@\S+\.\S+/.test(this.form.email) ? '' : 'Email invalide.'
            this.errors.iban = this.validateIban(this.form.iban) ? '' : 'IBAN invalide.'
            this.errors.consent = this.form.consent ? '' : 'Le consentement est requis.'

            return Object.values(this.errors).every(err => err === '')
        },
        async submit() {
            if (!this.validateForm()) return

            this.loading = true

            try {
                
                savePaymentInfos(
                    {
                        name: this.form.name,
                        email: this.form.email,
                        iban: this.form.iban.replace(/\s+/g, ''),
                        consent: this.form.consent
                    }
                ).then(() => {
                    this.$toast.success('Informations de paiement mises à jour');
                }).catch(() => {
                    this.$toast.error('Erreur lors de la mise à jour des informations de paiement');
                });

                //this.resetForm()
            } catch (e) {
                alert(e.message)
            } finally {
                this.loading = false
            }
        },

        resetForm() {
            this.form.name = ''
            this.form.email = ''
            this.form.iban = ''
            this.form.consent = false
        },
        backToCalendar() {
			this.$router.push({name: 'Sessions'});
		}
    }
}
</script>
<style scoped>

.sepa-form {
  max-width: 400px;
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 1em;
}

.error {
  color: red;
  font-size: 0.8em;
}

.payment-buttons {
    margin-top: 2rem;
    display: flex;
    justify-content: space-around;
}
</style>